module.exports = __webpack_public_path__ + "img/I-00535_73.d710d1bd.jpg";